export const languages = [
  {
    key: "fr",
    value: "lang:french",
    flag: "circle-flags:lang-fr",
  },
  {
    key: "en",
    value: "lang:english",
    flag: "circle-flags:lang-en",
  },
  {
    key: "de",
    value: "lang:german",
    flag: "circle-flags:lang-de",
  },
  {
    key: "it",
    value: "lang:italian",
    flag: "circle-flags:it",
  },
  {
    key: "es",
    value: "lang:spanish",
    flag: "circle-flags:es",
  },
  {
    key: "es-ar",
    value: "lang:spanishArgentina",
    flag: "flag:ar-1x1",
  },
  {
    key: "tr",
    value: "lang:turkish",
    flag: "circle-flags:lang-tr",
  },
  {
    key: "ar",
    value: "lang:arabic",
    flag: "circle-flags:sa",
  },
  {
    key: "ja",
    value: "lang:japanese",
    flag: "circle-flags:lang-ja",
  },
];
